"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var paperArea_1 = require("../diagram/paperArea");
var authoringTools_1 = require("../widgets/authoringTools");
var classTree_1 = require("../widgets/classTree");
var instancesSearch_1 = require("../widgets/instancesSearch");
var linksToolbox_1 = require("../widgets/linksToolbox");
var workspaceContext_1 = require("./workspaceContext");
var resizableSidebar_1 = require("./resizableSidebar");
var accordion_1 = require("./accordion");
var accordionItem_1 = require("./accordionItem");
var WorkspaceMarkup = /** @class */ (function (_super) {
    tslib_1.__extends(WorkspaceMarkup, _super);
    function WorkspaceMarkup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.untilMouseUpClasses = [];
        _this.triggerWorkspaceEvent = function (key) {
            var onWorkspaceEvent = _this.props.onWorkspaceEvent;
            if (onWorkspaceEvent) {
                onWorkspaceEvent(key);
            }
        };
        _this.renderToolbar = function () {
            var _a = _this.props, hideToolbar = _a.hideToolbar, toolbar = _a.toolbar;
            if (hideToolbar) {
                return null;
            }
            return React.createElement("div", { className: 'ontodia__header' }, toolbar);
        };
        _this.renderLeftPanel = function () {
            var _a = _this.props, hidePanels = _a.hidePanels, editor = _a.editor, _b = _a.searchCriteria, searchCriteria = _b === void 0 ? {} : _b;
            if (hidePanels) {
                return null;
            }
            var items = [];
            items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'classTree', heading: 'Classes' },
                React.createElement(classTree_1.ClassTree, { view: _this.props.view, editor: _this.props.editor, onClassSelected: function (classId) {
                        var elementType = _this.props.model.createClass(classId);
                        _this.props.onSearchCriteriaChanged({ elementType: elementType });
                    } })));
            if (editor.inAuthoringMode) {
                items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'authoringTools', heading: 'Authoring Tools' },
                    React.createElement(authoringTools_1.AuthoringTools, { view: _this.props.view, editor: _this.props.editor, metadataApi: _this.props.metadataApi, selectedElementType: searchCriteria.elementType })));
            }
            items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'instancesSearch', heading: 'Instances' },
                React.createElement(instancesSearch_1.InstancesSearch, { view: _this.props.view, model: _this.props.model, criteria: searchCriteria, onCriteriaChanged: _this.props.onSearchCriteriaChanged })));
            return (React.createElement(resizableSidebar_1.ResizableSidebar, { dockSide: resizableSidebar_1.DockSide.Left, isOpen: _this.props.isLeftPanelOpen, onOpenOrClose: _this.props.onToggleLeftPanel, onStartResize: function () { return _this.untilMouseUp({
                    preventTextSelection: true,
                    horizontalResizing: true,
                }); } },
                React.createElement(accordion_1.Accordion, { key: "accordion--" + (editor.inAuthoringMode ? 'exploring' : 'authoring'), onStartResize: function () { return _this.untilMouseUp({
                        preventTextSelection: true,
                        verticalResizing: true,
                    }); } }, items)));
        };
        _this.renderRightPanel = function () {
            if (_this.props.hidePanels) {
                return null;
            }
            var _a = _this.props, view = _a.view, editor = _a.editor, elementsSearchPanel = _a.elementsSearchPanel;
            var items = [];
            items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'connections', heading: 'Connections', bodyClassName: 'link-types-toolbox' },
                React.createElement(linksToolbox_1.LinkTypesToolbox, { view: view, editor: editor })));
            if (elementsSearchPanel) {
                items.push(React.createElement(accordionItem_1.AccordionItem, { key: 'search', heading: 'Search in diagram' }, React.cloneElement(elementsSearchPanel, { view: view, editor: editor })));
            }
            return (React.createElement(resizableSidebar_1.ResizableSidebar, { dockSide: resizableSidebar_1.DockSide.Right, isOpen: _this.props.isRightPanelOpen, onOpenOrClose: _this.props.onToggleRightPanel, onStartResize: function () { return _this.untilMouseUp({
                    preventTextSelection: true,
                    horizontalResizing: true,
                }); } },
                React.createElement(accordion_1.Accordion, { onStartResize: function () { return _this.untilMouseUp({
                        preventTextSelection: true,
                        verticalResizing: true,
                    }); } }, items)));
        };
        _this.onDocumentMouseUp = function () {
            for (var _i = 0, _a = _this.untilMouseUpClasses; _i < _a.length; _i++) {
                var className = _a[_i];
                _this.element.classList.remove(className);
            }
            _this.untilMouseUpClasses = [];
        };
        return _this;
    }
    WorkspaceMarkup.prototype.getChildContext = function () {
        var editor = this.props.editor;
        var ontodiaWorkspace = { editor: editor, triggerWorkspaceEvent: this.triggerWorkspaceEvent };
        return { ontodiaWorkspace: ontodiaWorkspace };
    };
    WorkspaceMarkup.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (e) { return _this.element = e; }, className: 'ontodia' },
            this.renderToolbar(),
            React.createElement("div", { className: 'ontodia__workspace' },
                this.renderLeftPanel(),
                React.createElement("div", { className: 'ontodia__main-panel' },
                    React.createElement(paperArea_1.PaperArea, { ref: function (el) { return _this.paperArea = el; }, view: this.props.view, zoomOptions: this.props.zoomOptions, hideScrollBars: this.props.hideScrollBars, watermarkSvg: this.props.watermarkSvg, watermarkUrl: this.props.watermarkUrl, onDragDrop: function (e, position) { return _this.props.editor.onDragDrop(e, position); }, onZoom: this.props.onZoom })),
                this.renderRightPanel())));
    };
    WorkspaceMarkup.prototype.componentDidMount = function () {
        document.addEventListener('mouseup', this.onDocumentMouseUp);
    };
    WorkspaceMarkup.prototype.componentWillUnmount = function () {
        document.removeEventListener('mouseup', this.onDocumentMouseUp);
    };
    WorkspaceMarkup.prototype.preventTextSelection = function () {
        this.untilMouseUp({ preventTextSelection: true });
    };
    WorkspaceMarkup.prototype.untilMouseUp = function (params) {
        this.untilMouseUpClasses = [];
        if (params.preventTextSelection) {
            this.untilMouseUpClasses.push('ontodia--unselectable');
        }
        if (params.horizontalResizing) {
            this.untilMouseUpClasses.push('ontodia--horizontal-resizing');
        }
        if (params.verticalResizing) {
            this.untilMouseUpClasses.push('ontodia--vertical-resizing');
        }
        for (var _i = 0, _a = this.untilMouseUpClasses; _i < _a.length; _i++) {
            var className = _a[_i];
            this.element.classList.add(className);
        }
    };
    WorkspaceMarkup.childContextTypes = workspaceContext_1.WorkspaceContextTypes;
    return WorkspaceMarkup;
}(React.Component));
exports.WorkspaceMarkup = WorkspaceMarkup;
